import DBOperationsComb from "src/utils/dbOperationsComb";
import Constants from "src/utils/constants";
import Exception from "src/utils/exception";

const tableName = Constants.enums.TABLES_NAME_ENUM.EXCEPTIONS_TABLE;

async function logException(exceptionData) {
  try {
    return await DBOperationsComb.insertData(tableName, {
      ...exceptionData,
      created_at: new Date().toISOString()
    });
  } catch (error) {
    console.error("Failed to log exception:", error);
    return {
      error:
        error.message || "An unexpected error occurred while logging exception",
      id: null
    };
  }
}

async function getExceptions(config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  logException,
  getExceptions
};
